/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class RolesProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * set a role as default
   * @param roleUuid new default role identifier
   * @returns void
   * @throws ApiError
   */
  public postApiServiceauthorizationProcessesRolesSetDefaultEmployerRole(
    roleUuid: string,
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/processes/roles/{roleUuid}/setDefaultEmployerRole',
      path: {
        'roleUuid': roleUuid,
      },
    });
  }

  /**
   * call a configured api endpoint to create roles from an external source
   * @param requestBody
   * @returns any Successfully created roles from external source
   * @throws ApiError
   */
  public postApiServiceauthorizationProcessesExternalRolesSyncExternalHireRoles(
    requestBody: {
      companiesToSync: Array<{
        hireAccountBaseUrl?: string;
        hireAccountApiKey?: string;
        uuid?: string;
      }>;
      /**
       * schedule sync on a recurring basis, frequency is required if true
       */
      schedule: boolean;
      /**
       * frequency in minutes for recurring sync
       */
      frequency?: number;
    },
  ): CancelablePromise<{
    meta?: responsesPartMeta;
    success?: boolean;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/processes/externalRoles/syncExternalHireRoles',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Unschedule roles sync event for given companies
   * @param requestBody
   * @returns any Successfully unscheduled roles sync event
   * @throws ApiError
   */
  public postApiServiceauthorizationProcessesExternalRolesStopSyncExternalHireRoles(
    requestBody: {
      companiesToStopSync: Array<{
        uuid?: string;
      }>;
    },
  ): CancelablePromise<{
    meta?: responsesPartMeta;
    success?: boolean;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/processes/externalRoles/stopSyncExternalHireRoles',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
